// extracted by mini-css-extract-plugin
module.exports = {"overviewHealth":"overviewHealth-3BtQMOTFYJyZfA2HtpXDP2","healthBadge":"healthBadge-bMMxscYKHht1qBTKHWAqd"};